<div class="not-found-top">
    <img
        src="../assets/images/logo.png"
        class="not-found-logo"
        alt="CLARK logo" />
    <strong><h1 tabindex="0" class="huge">404</h1></strong>
    <p tabindex="0" class="message">
        The page you are looking for was not found.
    </p>
    <a tabindex="0" routerLink="" class="message">Back to Home</a>
</div>
